import type { IEvent } from 'bz-utilities/modules/plugins/register/stores/mediator';

export class LicenseCountEvent implements IEvent {
  public constructor(init?: Partial<LicenseCountEvent>) {
    (Object as any).assign(this, init);
  }
}
